import { RootWrapper } from './src';

export const wrapRootElement = RootWrapper;
